import { defineMessages } from "react-intl";
const messages = defineMessages({
    filterDates: {
        id: "app.scanCompleted.table.filterDates.placeholder",
        defaultMessage: "Filter Dates",
    },
    filterDatesSubmit: {
        id: "app.scanCompleted.table.filterDates.submit",
        defaultMessage: "Submit",
    },
    filterSingleDateLabel: {
        id: "app.scanCompleted.table.filterDates.singleDate.label",
        defaultMessage: "Single Date",
    },
    filterStartDateLabel: {
        id: "app.scanCompleted.table.filterDates.startDate.label",
        defaultMessage: "Start Date",
    },
    filterStartDatePlaceholder: {
        id: "app.scanCompleted.table.filterDates.startDate.placeholder",
        defaultMessage: "mm/dd/yy",
    },
    filterEndDatePlaceholder: {
        id: "app.scanCompleted.table.filterDates.endDate.placeholder",
        defaultMessage: "mm/dd/yy",
    },
    filterStartDateError: {
        id: "app.scanCompleted.table.filterDates.startDate.error",
        defaultMessage: "The format date is wrong, use mm/dd/yy",
    },
    filterEndDateError: {
        id: "app.scanCompleted.table.filterDates.endDate.error",
        defaultMessage: "The format date is wrong, use mm/dd/yy",
    },
    filterEndDateBeforeStartDateError: {
        id: "app.scanCompleted.table.filterDates.endDateBeforeStartDate.error",
        defaultMessage: "End Date Should not be before Start Date",
    },
    filterStartDateRequired: {
        id: "app.scanCompleted.table.filterDates.startDate.required",
        defaultMessage: "Start Date is required",
    },
    filterEndDateRequired: {
        id: "app.scanCompleted.table.filterDates.endDate.required",
        defaultMessage: "End Date is required",
    },
});
export default messages;
